//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('consignmentCarrierOne', {
//        templateUrl: 'views/components/views/consignmentCarrierOne/consignmentCarrierOne.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'consignmentCarrierOneService', 'ttGridFactory', function ($stateParams, stateService, translateService, modalService, consignmentCarrierOneService, ttGridFactory) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let consignmentKeyno = $stateParams.consignment_keyno;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                gridReady: false,
//                setting: {},
//                lockedSave: false
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: 'w_consignmentcollidetail_carriers_grid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            });
            
//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.setting = (await consignmentCarrierOneService.getConsignmentCarrierOne({ consignment_keyno: consignmentKeyno }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region GRID PROCEDURE FUNCTION CALLS

//            async function loadGrid() {
//                vm.grid.dataTask.loadData = {
//                    method: 2668,
//                    parameters: vm.model.setting
//                };

//                vm.model.gridReady = true;

//                if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//            }

//            // #endregion GRID PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;
//                let allData = vm.grid.gridfunc.getAllRows();
//                let mergeObj = vm.model.setting;

//                mergeObj.records = allData.map(function (a) {
//                    return {
//                        "carrier_keyno": a.carrier_keyno,
//                        "quantity": a.quantity,
//                        "consignmentcarrier_keyno": a.consignmentcarrier_keyno
//                    };
//                });

//                consignmentCarrierOneService.saveObj(mergeObj).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                            title: translations.error,
//                    		message: response[0].errormessage,
//                    		buttons: [{
//                                label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: function (dialogItself) {
//                    				dialogItself.close();
//                    				vm.model.lockedSave = false;
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	vm.model.lockedSave = false;
//                    	stateService.back();		
//                    }
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                translate();
//                await loadSetting();
//                loadGrid();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
